import type { StatusHistory } from '../../../types/order';

/**
 * „Potwierdzenie klienta” of the Oferta step (makieta `sOferta`). The owner
 * decided on no new column: the acceptance is written as the note of the
 * CONFIRMED status change, so it stays in the status history.
 */
export interface OfferAcceptance {
  accepted: boolean;
  /** `YYYY-MM-DD` */
  date: string | null;
  person: string;
  notes: string;
}

export const OFFER_ACCEPTANCE_NOTES_MAX = 500;

export const emptyOfferAcceptance = (): OfferAcceptance => ({ accepted: false, date: null, person: '', notes: '' });

const toPolishDate = (isoDate: string) => {
  const [year, month, day] = isoDate.split('-');
  return `${day}.${month}.${year}`;
};

/** Status-history note of „Zarejestruj potwierdzenie”; empty when nothing was entered. */
export function buildOfferAcceptanceNote(acceptance: OfferAcceptance): string {
  const parts: string[] = [];
  if (acceptance.accepted) {
    const date = acceptance.date ? ` ${toPolishDate(acceptance.date)}` : '';
    const person = acceptance.person.trim() ? `, osoba potwierdzająca: ${acceptance.person.trim()}` : '';
    parts.push(`Klient zaakceptował ofertę${date}${person}.`);
  }
  const notes = acceptance.notes.trim().slice(0, OFFER_ACCEPTANCE_NOTES_MAX);
  if (notes) parts.push(`Uwagi klienta: ${notes}`);
  return parts.join(' ');
}

/** The newest history entry of a status (e.g. the CONFIRMED note for the Oferta preview). */
export function findLatestStatusEntry(history: readonly StatusHistory[] | undefined, status: string): StatusHistory | null {
  return [...(history ?? [])]
    .filter((entry) => entry.status === status)
    .sort((a, b) => new Date(b.changedAt).getTime() - new Date(a.changedAt).getTime())[0] ?? null;
}
